// @flow
import * as React from 'react'
import { type ContentfulNode } from '@mondough/contentful'

import EventsSpeakersList from '../../components/bespoke/EventsSpeakersList'
import { SectionWrapper, SectionThemes } from '../../components/SectionWrapper'
import {
  indexName,
  subtitleNodeName,
} from '@mondough/contentful/src/richTextDecorators'
import { getLocalisedFieldsFromNode } from '@mondough/contentful'
import { locale } from '../../Global'
import { defaultSubtitleSection } from '../defaultThemeComponents'

export const renderEventsSpeakersList = (node: ContentfulNode) => {
  const index = node[indexName]
  const reverse = index !== undefined ? index % 2 === 0 : false
  const {
    bespokeContent: { speakers },
  } = getLocalisedFieldsFromNode(node, locale) || {}

  return (
    <SectionWrapper theme={reverse ? SectionThemes.GREY : SectionThemes.LIGHT}>
      <EventsSpeakersList speakers={speakers}>
        {node[subtitleNodeName] &&
          defaultSubtitleSection(node[subtitleNodeName])}
      </EventsSpeakersList>
    </SectionWrapper>
  )
}
